module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Semibold.f5c9599f.woff";